import React, { useCallback, useState, FocusEvent } from 'react';
import { ErrorMessage, Field, FieldProps } from 'formik';
import { IconBaseProps } from 'react-icons/lib';
import NumberFormat, { NumberFormatProps } from 'react-number-format';
import { Container, Error } from '../styles';

interface InputProps extends NumberFormatProps {
  name: string;
  isFormatReal?: boolean;
  icon?: React.ComponentType<IconBaseProps>;
}

const Currency = ({
  form,
  field,
  ...props
}: NumberFormatProps & FieldProps) => (
  <NumberFormat
    id={field.name}
    name={field.name}
    value={field.value}
    onChange={e => form.setFieldValue(field.name, e.target.value)}
    {...props}
  />
);

export const InputFormat: React.FC<InputProps> = ({
  name,
  isFormatReal,
  icon: Icon,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);

  const currencyFormatter = (valueInput: any) => {
    if (!Number(valueInput)) return '';

    const amount = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valueInput / 100);

    return `${amount}`;
  };

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback((e: FocusEvent<HTMLInputElement>) => {
    setIsFilled(!!e.target.value);
    setIsFocused(false);
  }, []);

  return (
    <Container isFilled={isFilled} isFocused={isFocused}>
      <div>
        {Icon && <Icon size={20} id="input-icon" />}
        <Field
          id={name}
          name={name}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          format={isFormatReal ? currencyFormatter : undefined}
          component={Currency}
          {...rest}
        />
      </div>

      <ErrorMessage name={name} render={msg => <Error>{msg}</Error>} />
    </Container>
  );
};
